<template>
  <div class="fill-height">
    <line-chart
      v-if="viewMode === 'chart'"
      class="fill-height"
      :raw-data="removable ? playersDataMock : playersData"
      :chart-value-keys="[{ key: dirtyVariableKey, type: 'bar', label: variableKeyLabel }]"
      x-value="last_name"
      :y-value-prefix="removable ? 'player_stats.' : 'latest_stats.'"
      :colors="['#008FFB']"
      :xaxis="{
        labels: {
          rotate: -45
        },
        categories: players.map(p => p.first_name[0] + '. ' + p.last_name ),
        tickPlacement: 'between'
      }"
      :plot-options="{
        bar: {
          columnWidth: '60%',
          borderRadius: 4
        }
      }"
    >
      <template v-slot:header>
        <v-card-title class="pa-6 d-flex justify-space-between">
          <div class="subtitle-2 grey--text text--grey-100">
            {{ title }}
          </div>
          <v-btn
            v-if="removable"
            icon
            style="pointer-events: auto"
            @click="$emit('remove')"
          >
            <v-icon small>
              fal fa-times
            </v-icon>
          </v-btn>
          <visual-list-toggle
            v-else
            :value.sync="viewMode"
          />
        </v-card-title>
      </template>
    </line-chart>

    <v-card
      v-else-if="viewMode === 'table'"
      class="fill-height rounded-lg"
    >
      <v-card-title class="pa-6 d-flex justify-space-between">
        <div class="subtitle-2 grey--text text--grey-100">
          {{ title }}
        </div>
        <div class="d-flex align-center">
          <visual-list-toggle
            v-if="!removable"
            :value.sync="viewMode"
          />
        </div>
      </v-card-title>

      <v-data-table
        :headers="tableHeaders"
        :items="tableData"
        hide-default-footer
        disable-pagination
        :items-per-page="-1"
        fixed-header
        dense
        :height="350"
      >
        <template v-slot:item.last_name="{ item }">
          {{ item.last_name }}, {{ item.first_name }}
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import LineChart from '@/components/charts/LineChart.vue'
import VisualListToggle from '@/components/buttons/VisualListToggle.vue'
import { splitVariable } from '@/utils/helpers'

export default {
  name: 'PlayersBarChart',
  components: { LineChart, VisualListToggle },
  props: {
    players: {
      type: Array,
      required: true
    },
    variableKey: {
      type: String,
      required: true
    },
    removable: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    viewMode: 'chart'
  }),
  computed: {
    variableKeyLabel() {
      const varKey = splitVariable(this.variableKey)[0]

      return this.$t(`variables.${varKey}.long`)
    },
    playersData() {
      const data = this.players
        .filter(player => {
          return player.latest_stats &&
            player.latest_stats[this.variableKey] !== null &&
            player.latest_stats[this.variableKey] !== undefined
        })

      return data.sort((a, b) => b.value - a.value)
    },
    playersDataMock() {
      const varKey = splitVariable(this.variableKey)[0]

      return this.players
        .filter(player => {
          return player.player_stats &&
            player.player_stats[varKey] !== null &&
            player.player_stats[varKey] !== undefined
        })
    },
    dirtyVariableKey() {
      const varKey = splitVariable(this.variableKey)[0]

      return this.removable ? varKey : this.variableKey
    },
    title() {
      const varKey = splitVariable(this.variableKey)[0]
      const suffix = splitVariable(this.variableKey)[1]

      return this.$t(`variables.${suffix}.long`) + ': ' + this.$t(`variables.${varKey}.long`)
    },
    tableData() {
      const data = this.removable ? this.playersDataMock : this.playersData
      const valuePrefix = this.removable ? 'player_stats' : 'latest_stats'

      return data.map(player => ({
        ...player,
        value: player[valuePrefix][this.dirtyVariableKey]
      }))
    },
    tableHeaders() {
      return [
        {
          text: this.$t('table_headers.name'),
          value: 'last_name',
          sortable: true,
          width: '60%'
        },
        {
          text: this.variableKeyLabel,
          value: 'value',
          sortable: true,
          align: 'center'
        }
      ]
    }
  }
}
</script>
